import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.group_of_activities'),
      minWidth: 220,
      sortable: true,
    },
    {
      prop: 'name',
      label: `${i18n.t('common_words.activities')}`,
      show: false,
      activityGroup: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
